'use client'

import color from '@ui/style/color.theme'

interface Icon24DislikeProps {
	isDisliked?: boolean
}
export const Icon24Dislike = ({ isDisliked }: Icon24DislikeProps) => {
	const colorValue = isDisliked ? color.colPointBlue : color.colBlack
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
		>
			<path
				d="M15.5 15.8148L12.7974 20.2737C12.5241 20.7246 12.0351 21 11.5079 21V21C10.6751 21 10 20.3249 10 19.4921L10 15.8148L7.03111 15.8148C5.73954 15.8148 4.78665 14.6089 5.08533 13.3523L6.22978 8.5375C6.44401 7.63621 7.24917 7 8.17557 7L15.5 7L15.5 15.8148Z"
				stroke={colorValue}
				strokeWidth="1.5"
			/>
			<rect
				x="19.5"
				y="16"
				width="4"
				height="9"
				transform="rotate(180 19.5 16)"
				stroke={colorValue}
				strokeWidth="1.5"
			/>
		</svg>
	)
}
